<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/router/views_mobagile/components/loader.vue";
import api from "@/axios";
import moment from "moment/moment";
// import { useMagicKeys, whenever } from '@vueuse/core'
import Swal from "sweetalert2";
import {nextTick} from "vue";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Transferência",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Loader, Layout, PageHeader, Multiselect },
  data() {
    return {
      title: "Transferência",
      items: [
        {
          text: "Coletor",
          href: "/coletor/transferenciacoletor",
        },
        {
          text: "Tranferência",
          active: true
        }
      ],

      idData: 0,
      updating: true,
      tamanhoTela: 0,
      activeStep: 1,

      endOrigem: null,
      endwmsOrigem: null,
      endwmsDestino: null,
      itemRemanejarWriteOrigem: {
        endwms: null
      },
      dtlistPesqEndereco: [],
      dtlistPesqEndwmsDest: [],
      dtlistProdSaldoLoc: [],
      showListConfig: false,
      showModalProdSaldoLoc: false,
      flagConferenciaCompos: false,
      destModoInput: false,
      tipoTransfer: true,
      defpaletemode: true,
      prodInputMode: true,
      tipoConfer: 'A',
      selectedItem: null,
      paleteData: {},
      produtoTransf: null,
      paleteOrigem: null,
      paleteDest: null,
      transfItemData: {},
      transfItensSepData: [],
      transfItensSepPendData: [],
      submitted: false,
      showConfManual: false,
      empreAtu: null,
      codempreAtu: null,
      dtlistPesqProd: null,
      loadingProd: true
    }
  },

  created() {
  },

  computed: {
  },

  mounted() {
    console.log('mounted_tranferencia_0')
    this.tamanhoTela = window.innerWidth

    this.carregarDados()
  },

  methods: {
    carregarDados(){
      this.title = `Transferência de Estoque`
      this.updating = false
      nextTick(() => {
        if(this.defpaletemode === true) {
          this.$refs.palete.focus()
        } else {
          this.$refs.inputproduto.focus()
        }
      })
    },

    goToStep(step){
      console.log('goToStep')

      this.activeStep = step;
      nextTick(() => {
        if(step === 1) {
          if(this.defpaletemode === false) {
            if(!this.produtoTransf) {
              this.$refs.inputproduto.focus()
            } else {
              this.$refs.origem.focus()
            }
          } else {
            this.$refs.palete.focus()
          }
        } else if(step === 2) {
          if(!this.paleteDest === true) {
            this.$refs.paletedest.focus()
          } else {
            this.$refs.destino.focus()
          }
        }
      })
    },

    definiuOrigem() {
      console.log('definiuOrigem')

      if(this.dtlistProdSaldoLoc?.length > 0) {
        this.goToStep(2)
      } else {
        this.escolheuEndOrigem()
      }
    },

    definiuDestino() {
      console.log('definiuDestino')

      if(!this.endwmsDestino){
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Favor definir endereço de destino!",
          showConfirmButton: false,
          timer: 2500
        })
      } else {
        this.escolheuEndDestino()
      }
    },

    onChange() {
      this.$nextTick(() => {
        if(this.defpaletemode === false) {
          if(!this.produtoTransf) {
            this.$refs.inputproduto.focus()
          } else {
            this.$refs.origem.focus()
          }
        } else {
          this.$refs.palete.focus()
        }
      })
    },

    pesqProd(evt) {
      //console.log('pesqProd')
      //console.log(evt)
      let query = evt
      //console.log(query.length)
      if (query.length > 1) {
        this.dtlistPesqProd = null
        this.loadingProd = true
        api.get(`${getBaseUrl()}api/prodpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios pesqprod:')
          console.log(res.data)
          this.dtlistPesqProd = res.data

          this.dtlistPesqProd.forEach((value) => {
            if (value.imgs) {
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
            }
            value['descrcodigo'] = value['codigo'] + ' ' + value['descricao'] + ' ' + value['codbarra']
          });

        })
      }
    },

    escolheuProd() {
      this.loadingProd = true
      api.get(`${getBaseUrl()}api/prodcodcoletor`, {
        params: { coddata: this.produtoTransf }
      }).then((res) => {
        console.log('then axios produtoTransf')
        console.log(res.data)

        if(res.data.success === true) {
          this.dtlistPesqEndereco = res.data.prodsaldoloc
          this.empreAtu = res.data.data.empreatu

          this.dtlistPesqEndereco.forEach((value) => {
            value['endwmspalete'] = 'EndWms: ' + value['endwms'] + ' Palete: ' + value['palete']
          });
          this.$nextTick(() => {
            this.$refs.origem.focus()
          })
          console.log('dtlistPesqEndereco: ' , this.dtlistPesqEndereco)
        } else {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: res.data.message,
            showConfirmButton: false,
            timer: 1500
          })
        }

        this.loadingProd = false
      })
    },

    /*informouInputProd() {
      console.log('informouInputProd')

      this.$nextTick(() => {
        if(this.defpalete === true) {
          this.$refs.palete.focus()
        } else {
          this.$refs.origem.focus()
        }
      })
    },*/

    informouPalete() {
      console.log('informouPalete')

      if(!this.paleteOrigem) {
        console.log("Erro: Necessário definir palete.");
        Swal.fire({
          position: "center",
          icon: "error",
          title: 'Necessário definir o Palete de Origem.',
          showConfirmButton: false,
          timer: 2500
        })
        nextTick(() => {
          this.$refs.palete.focus()
        })
      } else {
        nextTick(() => {
          this.$refs.origem.focus()
        })
      }
    },

    informouPaleteDest() {
      console.log('informouPaleteDest')

      if(!this.paleteDest) {
        console.log("Erro: Necessário definir palete.");
        Swal.fire({
          position: "center",
          icon: "error",
          title: 'Necessário definir o Palete de Destino.',
          showConfirmButton: false,
          timer: 2500
        })
        nextTick(() => {
          this.$refs.paletedest.focus()
        })
      } else {
        nextTick(() => {
          this.$refs.destino.focus()
        })
      }

    },

    pesqEndereco(evt) {
      console.log('pesqEndereco')
      // console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/enderpes`, {
          params: { q: query, origem: "movtransf", origem_id: null }
        }).then((res) => {
          console.log('then axios')
          // console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqEndereco = res.data
        })
      }
    },

    pesqEndwmsDest(evt) {
      console.log('pesqEndereco')
      // console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/enderpes`, {
          params: { q: query, origem: "movtransf", origem_id: null }
        }).then((res) => {
          console.log('then axios')
          // console.log(res.data)
          this.dtlistPesqEndwmsDest = res.data
        })
      }
    },

    filtrarDisponiveis(arrayEntr) {
      console.log('filtrarDisponiveis')
      let listaFiltrada = []
      arrayEntr.forEach((value) => {
        if (value.qtddisp > 0) {
          /*
          * Verificando se existe composição novamente
          */
          if(value.composicao) {
            this.flagConferenciaCompos = true
          }

          listaFiltrada.push(value)
        }
      });
      return listaFiltrada
    },

    escolheuEndOrigem(){
      console.log('escolheuEndOrigem')

      // limpando lista de produtos
      this.itemRemanejarWriteOrigem = []
      this.dtlistProdSaldoLoc = []
      this.selectedItem = null

      if(!this.produtoTransf && this.defpaletemode === false) {
        console.log("Erro ao buscar saldo de itens do endereço");
        Swal.fire({
          position: "center",
          icon: "error",
          title: 'Necessário definir o Produto de Transferência.',
          showConfirmButton: false,
          timer: 2500
        })
      } else if (this.defpaletemode === true && (!this.paleteOrigem || !this.endOrigem)) {
        console.log("Erro ao buscar saldo de itens do endereço");
        Swal.fire({
          position: "center",
          icon: "error",
          title: 'Necessário definir o Palete e Endereço de origem.',
          showConfirmButton: false,
          timer: 2500
        })
      } else {
        this.updating = true

        const paramsReq = {
          'origem': this.endOrigem,
          'palete': this.paleteOrigem,
          'defpaletemode': this.defpaletemode
        }

        api.get(`${getBaseUrl()}api/dadosnovoendremanejarsaldo`, {
          params: paramsReq
        }).then((res) => {
          console.log('then axios produto de transf.')
          console.log(res.data)
          this.updating = false

          if (res.data.success === true) {
            this.itemRemanejarWriteOrigem = res.data.data
            this.dtlistProdSaldoLoc = this.filtrarDisponiveis(res.data.data)

            this.codempreAtu = this.dtlistProdSaldoLoc[0].empresa
            this.endwmsOrigem = this.dtlistProdSaldoLoc[0].endwms
            this.paleteOrigem = this.dtlistProdSaldoLoc[0].palete

            this.goToStep(2)
          } else {
            Swal.fire({
              position: "center",
              icon: "error",
              title: res.data.message,
              text: `Empresa Atual: ${this.empreAtu}`,
              showConfirmButton: false,
              timer: 3000
            })
          }
        })
      }
    },

    escolheuEndDestino(){
      console.log('escolheuEndDestino')

      if(!this.paleteDest || !this.endwmsDestino) {
        console.log("Erro: Necessário definir palete.");
        Swal.fire({
          position: "center",
          icon: "error",
          title: 'Necessário definir o Palete e Endereço de destino.',
          showConfirmButton: false,
          timer: 2500
        })
        nextTick(() => {
          if(!this.paleteDest){
            this.$refs.paletedest.focus()
          } else {
            this.$refs.destino.focus()
          }
        })
      } else {
        if(this.tipoTransfer === true) {

          if(!this.paleteDest) {
            console.log("Warnig: Necessário definir palete.");
            Swal.fire({
              position: "center",
              icon: "warnig",
              title: 'Palete não definido, necessário definir o Palete de Destino.',
              showConfirmButton: false,
              timer: 2500
            })

            nextTick(() => {
              this.$refs.paletedest.focus()
            })
          } else {
            nextTick(() => {
              this.$refs.produto.focus()
            })
          }

        } else {
          console.log("Success: Todas as configurações feitas com sucesso.");
          Swal.fire({
            position: "center",
            icon: "success",
            title: 'Configurações de transferência feitas com sucesso!',
            showConfirmButton: false,
            timer: 2500
          })
        }
      }
    },

    clicouProduto(data) {
      console.log('=============== clicouProduto ===============')
      this.showModalProdSaldoLoc = false

      this.transfItemData.produto = data.produto
      this.transfItemData.produto_id = data.produto_id
      this.transfItemData.iditem = data.id
      this.transfItemData.lote = data.lote
      this.transfItemData.serie = data.serie
      this.transfItemData.dtvalid = data.dtvalid
      this.transfItemData.empresa = data.empresa
      this.transfItemData.palete = data.palete

      let compos_qtd = data.composicao?.qtd ?? null
      let compos_fator = data.composicao?.fator ?? null

      /*
      * Valida se conferência contém item composto
      */
      let qtddisp = 0
      let qtd = 0
      this.dtlistProdSaldoLoc.forEach((item) => {

        if (item.id === this.transfItemData.iditem) {
          this.transfItemData.compos_qtd = parseFloat(compos_qtd)
          this.transfItemData.compos_fator = compos_fator
          qtd = item.qtddisp
          qtddisp = item.qtddisp
          this.transfItemData.descprod = item.descprod
        }
      });

      this.transfItemData.qtd = qtd
      this.transfItemData.qtdlida = 0
      this.transfItemData.qtddisp = qtddisp

      this.$nextTick(() => {
        this.$refs.produto.focus()
      })

    },

    informouProduto() {
      console.log('=============== informouProduto ===============')
      if(!this.paleteDest || !this.endwmsDestino) {
        console.log("Erro ao tentar transferir saldo");
        Swal.fire({
          position: "center",
          icon: "error",
          title: !this.endwmsDestino || !this.paleteDest ? 'Necessário definir Palete e Endereço de destino.' : 'Dados não encotrados para a tranferência.',
          showConfirmButton: false,
          timer: 2500
        })
      } else {
        let encontrouProd = false
        if(!this.transfItemData || (!this.transfItemData.iditem && this.transfItemData.produto)) {
          console.log('primeiro caso')
          let qtddisp = 0
          let qtd = 0

          const value = this.dtlistProdSaldoLoc.find( p => (p.empresa === this.codempreAtu &&
              ((p.id === this.transfItemData.iditem) || (this.transfItemData.produto === p.produto) || (this.transfItemData.produto === p.codbarra))
          ))

          if(value) {
            this.transfItemData.produto = value.produto
            this.transfItemData.produto_id = value.produto_id
            this.transfItemData.descprod = value.descprod
            this.transfItemData.qtd = value.qtddisp
            this.transfItemData.iditem = value.id
            this.transfItemData.lote = value.lote
            this.transfItemData.serie = value.serie
            this.transfItemData.dtvalid = value.dtvalid
            this.transfItemData.empresa = value.empresa
            this.transfItemData.palete = value.palete

            if (value.id === this.transfItemData.iditem) {
              const composicao = value.composicao

              if(composicao){
                this.transfItemData.compos_qtd = parseFloat(composicao.qtd)
                this.transfItemData.compos_fator = composicao.fator
              }

              qtddisp = value.qtddisp
              qtd = value.qtddisp
              this.transfItemData.descprod = value.descprod
            }

            this.transfItemData.qtd = qtd
            this.transfItemData.qtdlida = 0
            this.transfItemData.qtddisp = qtddisp

            this.selectedItem = value;

            if (this.tipoConfer === 'A') {
              if(this.flagConferenciaCompos && this.transfItemData.compos_qtd > 0){
                this.transfItemData.qtdlida = this.roundToDecimal(parseFloat(this.transfItemData.compos_qtd), 4)
              }else{
                this.transfItemData.qtdlida = 1
              }
              this.informouQtdLida2()
            } else {
              this.transfItemData.qtdlida = value.qtddisp
              this.$refs.qtdlida.focus()
              this.abrirShowConfManual()
            }
            encontrouProd = true
          }
        } else {
          console.log('segundo caso')

          const value = this.dtlistProdSaldoLoc.find( p => (p.id === this.transfItemData.iditem) )

          if(value) {
            this.selectedItem = value;

            if (this.tipoConfer === 'A') {
              if(this.flagConferenciaCompos && this.transfItemData.compos_qtd > 0){
                console.log('quantidade produto composto')
                this.transfItemData.qtdlida = this.roundToDecimal(parseFloat(this.transfItemData.compos_qtd), 4)
              }else{
                console.log('quantidade automática')
                this.transfItemData.qtdlida = 1
              }

              this.transfItemData.produto = value.produto
              this.transfItemData.lote = value.lote
              this.transfItemData.serie = value.serie
              this.transfItemData.dtvalid = value.dtvalid
              this.transfItemData.empresa = value.empresa
              this.transfItemData.palete = value.palete
              this.informouQtdLida2()
            } else {
              this.transfItemData.qtdlida = value.qtddisp
              this.$refs.qtdlida.focus()
              this.abrirShowConfManual()
            }
            encontrouProd = true
          }
        }
        if (!encontrouProd) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Produto Inválido",
            text: "Código inválido ou já finalizado!",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500
          });
        }
      }
    },

    informouQtdLida2() {
      console.log('=============== informouQtdLida2 ===============')

      let passaSaldo = false
      let qtdLidaAtual = 0

      if (passaSaldo) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Quantidade indisponível, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })

      } else {
        console.log('acumular lista para separar muitos')

        this.showConfManual = false
        let quantDisponivel = false

        const prod = this.dtlistProdSaldoLoc.find( p => p.id === this.transfItemData.iditem)

        if(!prod.qtddisp){
          prod.qtddisp = this.transfItemData.qtddisp
        }

        qtdLidaAtual = this.roundToDecimal(parseFloat(this.transfItemData.qtdlida), 4);

        if (prod.composicao) {
          if (prod.qtddisp >= 0) {
            console.log('baixa de produto composição...');

            prod.qtdlida += qtdLidaAtual;
            prod.qtddisp = this.roundToDecimal((this.transfItemData.qtd - qtdLidaAtual), 4);
            quantDisponivel = true;

            // Validando se terminou de conferir o item atual
            if (prod.qtddisp < 0) {
              prod.qtddisp = 0;
              quantDisponivel = false;
            }
          }
        } else {
          console.log('baixa de produto comum...');

          if (prod.qtddisp >= qtdLidaAtual) {
            prod.qtdlida += qtdLidaAtual;
            prod.qtddisp = this.roundToDecimal((this.transfItemData.qtd - qtdLidaAtual), 4);
            quantDisponivel = true;
          }
        }

        if (prod.qtddisp === 0) {
          this.dtlistProdSaldoLoc.splice(this.dtlistProdSaldoLoc.indexOf(prod), 1);
        }

        if (quantDisponivel === false) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Quantidade do produto indisponível para separação",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2500
          })
        } else {
          if (this.transfItemData.lote || this.transfItemData.serie || this.transfItemData.dtvalid) {
            // console.log("LOTE INFORMADO", this.transfItemData)

            const lote = this.transfItemData.lote;
            const endwms = this.transfItemData.endwms
            const serie = this.transfItemData.serie
            const dtvalid = this.transfItemData.dtvalid
            const palete = this.transfItemData.palete

            let existeProdPend = false;
            let existeProd = false;

            /* verificando se lote já existe em wmsOsItensSepPendData */
            if(this.transfItensSepPendData?.length > 0) {
              this.transfItensSepPendData.forEach((prod) => {

                if( prod.iditem === this.transfItemData.iditem &&
                    prod.lote === this.transfItemData.lote &&
                    prod.serie === this.transfItemData.serie &&
                    prod.dtvalid === this.transfItemData.dtvalid
                ) {
                  existeProdPend = true;
                  console.log('atualizando dados do item na lista wmsOsItensSepPendData')

                  if (this.flagConferenciaCompos && this.transfItemData.compos_qtd) {
                    console.log('baixa qtd composição')

                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  } else {
                    console.log('baixa qtd comum')

                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  }
                }
              });
            }

            if(this.transfItensSepData.length > 0) {
              /* verificando se lote já existe em in wmsOsItensSepData */
              this.transfItensSepData.forEach((prod) => {

                if( prod.iditem === this.transfItemData.iditem &&
                    prod.lote === this.transfItemData.lote &&
                    prod.serie === this.transfItemData.serie &&
                    prod.dtvalid === this.transfItemData.dtvalid
                ) {
                  existeProd = true;
                  // console.log('atualizando dados do item na lista transfItensSepData')

                  if (this.flagConferenciaCompos && this.transfItemData.compos_qtd) {
                    console.log('baixa qtd composição')

                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  } else {
                    console.log('baixa qtd comum')

                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  }
                }
              });
            }

            /* Criando novos itens nas coleções */
            if (!existeProdPend) {
              console.log('criando novo item na lista wmsOsItensSepPendData')

              this.transfItensSepPendData.push({
                'id': this.transfItemData.iditem,
                'iditem': this.transfItemData.iditem,
                'descprod': this.transfItemData.descprod,
                'imgs': '',
                'empresa': this.transfItemData.empresa,
                'produto': this.transfItemData.produto,
                'produto_id': this.transfItemData.produto_id,
                'qtdlida': this.roundToDecimal(this.transfItemData.qtdlida, 4),
                'qtd': this.roundToDecimal(this.transfItemData.qtdlida, 4),
                'lote': lote,
                'endwms': endwms,
                'serie': serie,
                'dtvalid': dtvalid,
                'palete': palete,
                'qtdtotal': this.roundToDecimal((this.transfItemData.qtd - this.transfItemData.qtdlida), 4)
              });
            }

            if (!existeProd) {
              console.log('criando novo item na lista wmsOsItensSepData')

              this.transfItensSepData.push({
                'id': this.transfItemData.iditem,
                'iditem': this.transfItemData.iditem,
                'descprod': this.transfItemData.descprod,
                'imgs': '',
                'empresa': this.transfItemData.empresa,
                'produto': this.transfItemData.produto,
                'produto_id': this.transfItemData.produto_id,
                'qtdlida': this.roundToDecimal(this.transfItemData.qtdlida, 4),
                'qtd': this.roundToDecimal(this.transfItemData.qtdlida, 4),
                'lote': lote,
                'endwms': endwms,
                'serie': serie,
                'dtvalid': dtvalid,
                'palete': palete,
                'qtdtotal': this.roundToDecimal((this.transfItemData.qtd - this.transfItemData.qtdlida), 4)
              });
            }
          } else {
            console.log("LOTE NÃO INFORMADO")

            let existeProdPend = false;
            let existeProd = false;

            if(this.transfItensSepPendData?.length > 0) {
              this.transfItensSepPendData.forEach((prod) => {
                if (prod.iditem === this.transfItemData.iditem &&
                    prod.lote === this.transfItemData.lote &&
                    prod.serie === this.transfItemData.serie &&
                    prod.dtvalid === this.transfItemData.dtvalid
                ) {
                  existeProdPend = true;
                  if (this.flagConferenciaCompos && this.transfItemData.compos_qtd > 0) {
                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  } else {
                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  }
                }
              });
            }

            if(this.transfItensSepData?.length > 0) {
              this.transfItensSepData.forEach((prod) => {
                if (prod.iditem === this.transfItemData.iditem &&
                    prod.lote === this.transfItemData.lote &&
                    prod.serie === this.transfItemData.serie &&
                    prod.dtvalid === this.transfItemData.dtvalid
                ) {
                  existeProd = true;
                  if (this.flagConferenciaCompos && this.transfItemData.compos_qtd > 0) {
                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  } else {
                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  }
                }
              });
            }

            /*Criando novos itens nas coleções */
            if (!existeProdPend) {
              this.transfItensSepPendData.push({
                'id': this.transfItemData.iditem,
                'iditem': this.transfItemData.iditem,
                'descprod': this.transfItemData.descprod,
                'imgs': '',
                'empresa': this.transfItemData.empresa,
                'produto': this.transfItemData.produto,
                'produto_id': this.transfItemData.produto_id,
                'qtdlida': this.transfItemData.qtdlida,
                'qtd': this.transfItemData.qtdlida,
                'qtdtotal': this.roundToDecimal((this.transfItemData.qtd - this.transfItemData.qtdlida), 4),
                'lote': this.transfItemData.lote ?? null,
                'endwms': this.transfItemData.endwms ?? null,
                'serie': this.transfItemData.serie ?? null,
                'dtvalid': this.transfItemData.dtvalid ?? null,
                'palete': this.transfItemData.palete  ?? null,
              });
            }

            if (!existeProd) {
              this.transfItensSepData.push({
                'id': this.transfItemData.iditem,
                'iditem': this.transfItemData.iditem,
                'descprod': this.transfItemData.descprod,
                'imgs': '',
                'empresa': this.transfItemData.empresa,
                'produto': this.transfItemData.produto,
                'produto_id': this.transfItemData.produto_id,
                'qtdlida': this.transfItemData.qtdlida,
                'qtd': this.transfItemData.qtdlida,
                'qtdtotal': this.roundToDecimal((this.transfItemData.qtd - this.transfItemData.qtdlida), 4),
                'lote': this.transfItemData.lote ?? null,
                'endwms': this.transfItemData.endwms ?? null,
                'serie': this.transfItemData.serie ?? null,
                'dtvalid': this.transfItemData.dtvalid ?? null,
                'palete': this.transfItemData.palete ?? null,
              });
            }
          }

          //ordenando em desc e destacando o item atual para o topo
          const idItemAtual = this.transfItemData.iditem

          const itemAtual = this.transfItensSepData.find( item => item.iditem === idItemAtual );
          const outrosItens = this.transfItensSepData.filter( item => !(item.iditem === idItemAtual) );

          if (outrosItens && outrosItens.length > 0) {
            outrosItens.sort((a, b) => b.iditem - a.iditem);
            this.transfItensSepData = itemAtual ? [itemAtual, ...outrosItens] : outrosItens;
          } else if (itemAtual) {
            this.transfItensSepData = [itemAtual]
          }

          if (this.dtlistProdSaldoLoc.length === 0) {
            this.confirmarRemanejo()
          }

          console.log('limpando wmsOsItemData')
          this.transfItemData = {}

          console.log('retornando foco')
          this.$refs.produto.focus()
        }
      }
    },

    confirmarRemanejo(){
      console.log('confirmarRemanejo')

      const transfItensData = this.tipoTransfer === false ? this.itemRemanejarWriteOrigem : this.transfItensSepPendData;

      if(!transfItensData || (!this.paleteDest || !this.endwmsDestino)) {
        console.log("Erro ao tentar transferir saldo");
        Swal.fire({
          position: "center",
          icon: "error",
          title: !this.endwmsDestino || !this.paleteDest ? 'Necessário definir Palete e Endereço de destino.' : 'Dados não encotrados para a tranferência.',
          showConfirmButton: false,
          timer: 2500
        })
      } else {
        Swal.fire({
          position: "center",
          icon: "info",
          title: "Deseja efetivar tranferência?",
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(confirmed => {
          this.updating = true
          if(confirmed.isConfirmed){
            api.post(`${getBaseUrl()}api/remanejsaldoprodcoletor`, {
              itemSaldoRemaneja: transfItensData,
              endwmsDestino: this.endwmsDestino,
              tipoTransfer: this.tipoTransfer,
              palete: this.paleteDest

            }).then((res) => {
              console.log('then axios remanejsaldo')
              console.log(res.data)

              this.updating = false
              if(res.data.success){
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: res.data.message,
                  showConfirmButton: false,
                  timer: 2500
                }).then(() => {
                  this.atualizaPagina()
                })
              } else {
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: res.data.message,
                  showConfirmButton: false,
                  timer: 2500
                })
              }
            })
          }
        })
      }
    },

    roundToDecimal(num, decimalPlaces) {
      const factor = Math.pow(10, decimalPlaces);
      return Math.round(num * factor) / factor;
    },

    abrirShowConfManual() {
      console.log('abrirshowConfManual')

      this.showConfManual = true
      this.$refs.qtdlida.focus()
    },

    fechouModalProdSaldoLoc(){
      nextTick(() => {
        if(this.tipoTransfer === false || (!this.endwmsDestino)) {
          if(this.defpalete === true) {
            this.$refs.paletedest.focus()
          } else {
            this.$refs.destino.focus()
          }
        } else {
          this.$refs.produto.focus()
        }
      })
    },

    fechouModalListConfig(){
      nextTick(() => {
        if(this.tipoTransfer === false || (!this.endwmsDestino)) {
          if((!this.endOrigem || !this.produtoTransf) && this.activeStep === 1){
            if(!this.produtoTransf) {
              this.$refs.inputproduto.focus()
            } else {
              if(this.defpalete === true) {
                this.$refs.palete.focus()
              } else {
                this.$refs.origem.focus()
              }
            }
          } else {
            if(this.defpalete === true) {
              this.$refs.paletedest.focus()
            } else {
              this.$refs.destino.focus()
            }
          }
        } else {
          this.$refs.produto.focus()
        }
      })
    },

    atualizaPagina() {
      window.location.reload();
    },

    retornaParaMenu() {
      console.log('retorna para menu')
      this.$router.replace('/produtos/listestoque')
    },

    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
          !document.fullscreenElement &&
          /* alternative standard method */ !document.mozFullScreenElement &&
          !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
              Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2 });
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 0 });
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },

};
</script>
<template>
    <div v-if="tamanhoTela > 500">
      <Layout>
        <PageHeader :title="title" :items="items"/>

        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="d-flex col-10">
                  <h5>Tranferência de Estoque</h5>
                  <div class="mx-3 font-size-14 col-6">
                    <b-form-checkbox switch size="sm" v-model="tipoTransfer">
                      {{ tipoTransfer === false ? 'Modo Full' : 'Modo Unit.' }}
                    </b-form-checkbox>
                  </div>
                </div>
                <div v-if="empreAtu" >
                  <span class="font-size-10"><strong>Empresa Atual: </strong>{{this.empreAtu}}</span>
                </div>

                <div class="row">
                  <div class="d-flex justify-content-between align-items-baseline col-6 mb-2"  style="margin-top: 5px">

                    <button title="Reiniciar" class="btn p-1 m-1 mx-4 border-0 font-size-16" @click="atualizaPagina">
                      <i class="bx bx-sync"></i>
                    </button>

                    <button title="Lista de produtos a transferir" type="button" :disabled="dtlistProdSaldoLoc?.length < 1" class="btn p-1 m-1 mx-4 border-0 font-size-16"
                            @click="showModalProdSaldoLoc = true">
                      <i class="bx bx-list-ul"></i>
                    </button>

                    <button title="Ferramentas" type="button" class="btn p-1 m-1 mx-4 border-0 font-size-16"
                            disabled>
                      <i class="bx bx-layer "></i>
                    </button>

                    <button title="Modo FullScreen" type="button" class="btn p-1 m-1 mx-4 border-0 font-size-14" @click="initFullScreen">
                      <i class="bx bx-fullscreen"></i>
                    </button>

<!--                    <b-form-checkbox switch size="sm" v-model="defpaletemode" @change="onChange">
                      {{ defpaletemode === false ? 'Produto Mode' : 'Palete Mode' }}
                    </b-form-checkbox>-->

                    <b-form-checkbox switch size="sm" v-model="destModoInput">
                      {{ destModoInput === false ? 'End. Modo Input' : 'End Modo Multiselect' }}
                    </b-form-checkbox>

                    <b-form-checkbox switch size="sm" value="A" unchecked-value="I" v-model="tipoConfer">
                      {{ tipoConfer === 'A' ? 'Conf. Auto' : 'Conf. Manual' }}
                    </b-form-checkbox>

                  </div>

                  <div class="col-6 text-end">
                    <b-button type="button"
                              variant="success"
                              size="sm"
                              @click="confirmarRemanejo"
                              :disabled="dtlistProdSaldoLoc?.length < 1">
                      <i class="bx bx-check-double"></i>
                      Finalizar Trasnfer.
                    </b-button>
                  </div>
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-12 d-flex justify-content-start align-items-baseline mb-2">
                  <span class="me-1">{{ defpaletemode === false ? 'Produto Mode' : 'Palete Mode' }}</span>
                  <b-form-checkbox switch size="sm" v-model="defpaletemode" @change="onChange"/>
                </div>

                <div v-if="idData === 0" class="row col-6 mb-5">

                  <div class="col-sm-5 mb-2" v-if="!defpaletemode">
                    <label for="inputproduto">Produto de Transferência</label>
                    <input v-if="prodInputMode === true"
                           id="inputproduto"
                           v-model="produtoTransf"
                           type="text"
                           class="form-control compact-input"
                           placeholder="Produto de Transferência ( ID / Código )"
                           ref="inputproduto"
                           @keydown.enter.prevent="escolheuProd"
                    />

                    <multiselect id="origem" v-if="prodInputMode === false"
                                 @search-change="pesqProd"
                                 @select="escolheuProd"
                                 v-model="produtoTransf"
                                 class="form-control compact-input"
                                 placeholder="Produto de Transferência (ID / Código)"
                                 :options="dtlistPesqProd"
                                 :searchable="true"
                                 ref="inputproduto"
                                 label="descricao"
                                 track-by="descrcodigo"
                                 value-prop="codigo">
                      <template #option="slotProps">
                        <div class="row">
                          <div class="font-size-12">
                          <span class="text-info">
                            {{ slotProps.option.id }}
                          </span>
                            <span class="mx-4 text-dark">
                          {{ slotProps.option.codigo }}
                        </span>
                          </div>
                          <div class="ms-0 font-size-12 text-muted">
                            {{
                              slotProps.option.descricao?.length > 32 ?
                                  slotProps.option.descricao.substring(0, 32) + '...' :
                                  slotProps.option.descricao
                            }}
                          </div>
                        </div>
                      </template>
                    </multiselect>
                  </div>

                  <div class="col-sm-5 mb-2"  v-if="!defpaletemode"></div>

                  <div class="col-sm-10 mb-2" v-if="!defpaletemode && dtlistPesqEndereco?.length > 0">
                    <label for="origem">Endereço de Origem </label>
                    <multiselect id="origem" v-if="destModoInput === false"
                                 @select="escolheuEndOrigem"
                                 v-model="endOrigem"
                                 placeholder="Selecione o endereçamento de origem"
                                 :options="dtlistPesqEndereco"
                                 :searchable="false"
                                 ref="origem"
                                 label="endwmspalete"
                                 track-by="endwmspalete"
                                 value-prop="id">
                      <template #option="slotProps">
                        <div class="row">
                          <div class="font-size-12">
                            <span class="text-dark">
                            Endereço: {{ slotProps.option.endwms }}
                          </span>
                            <span class="ms-4 text-dark">
                            Palete: {{ slotProps.option.palete ?? 'S/Palete' }}
                          </span>
                          </div>
                          <div class="font-size-12 text-muted">
                            Saldo: {{ formatDecimal(slotProps.option.saldo) }}
                          </div>
                        </div>
                      </template>
                    </multiselect>
                  </div>

                  <div class="col-sm-5 mb-2" v-if="defpaletemode">
                    <label for="palete">Palete Origem</label>
                    <input
                        id="palete"
                        v-model="paleteOrigem"
                        type="text"
                        class="form-control compact-input"
                        placeholder="Palete Origem"
                        ref="palete"
                        @keydown.enter.prevent="informouPalete"
                    />
                  </div>

                  <div class="col-sm-5 mb-2" v-if="defpaletemode">
                    <label for="origem">Endereço de Origem </label>
                    <input id="origem" v-if="destModoInput === false"
                           v-model="endOrigem"
                           type="text"
                           class="form-control compact-input"
                           placeholder="Definir Origem"
                           ref="origem"
                           @keydown.enter.prevent="escolheuEndOrigem" />

                    <!-- Para tela maior input manual -->
                    <multiselect id="origem" v-if="destModoInput === true"
                                 @search-change="pesqEndereco"
                                 @select="escolheuEndOrigem"
                                 v-model="endOrigem"
                                 placeholder="Definir Origem"
                                 :options="dtlistPesqEndereco"
                                 :searchable="true"
                                 ref="origem"
                                 label="descricao"
                                 track-by="descricao"
                                 value-prop="descricao">
                      <template #option="slotProps">
                        <div class="row">
                          <div class="font-size-12">
                            <span class="text-info">
                              {{ slotProps.option.id }}
                            </span>
                            <span class="mx-4 text-dark">
                              {{ slotProps.option.descricao }}
                            </span>
                          </div>
                          <div class="align-items-end text-end align-content-end font-size-12 text-muted">
                            {{ formatDateTime(slotProps.option.created_at) }}
                          </div>
                        </div>
                      </template>
                    </multiselect>

                  </div>

                  <div class="col-sm-5 mb-3">
                    <label for="paletedest">Palete Destino</label>
                    <input
                        id="paletedest"
                        v-model="paleteDest"
                        type="text"
                        class="form-control compact-input"
                        placeholder="Palete Destino"
                        ref="paletedest"
                        :disabled="dtlistProdSaldoLoc?.length < 1"
                        @keydown.enter.prevent="informouPaleteDest"
                    />
                  </div>

                  <div class="col-sm-5 mb-3">
                    <label for="destino">Endereço Destino</label>
                    <input id="destino" v-if="destModoInput === false"
                           v-model="endwmsDestino"
                           type="text"
                           class="form-control compact-input"
                           placeholder="Endereço Destino"
                           ref="destino"
                           :disabled="dtlistProdSaldoLoc?.length < 1"
                           @keydown.enter.prevent="escolheuEndDestino" />

                    <!-- Para tela maior input manual -->
                    <multiselect id="destino" v-if="destModoInput === true"
                                 @search-change="pesqEndwmsDest"
                                 @select="escolheuEndDestino"
                                 v-model="endwmsDestino"
                                 placeholder="End. Destino"
                                 :options="dtlistPesqEndwmsDest"
                                 :searchable="true"
                                 ref="destino"
                                 :disabled="dtlistProdSaldoLoc?.length < 1"
                                 label="descricao"
                                 track-by="descricao"
                                 value-prop="descricao">
                      <template #option="slotProps">
                        <div class="row">
                          <div class="font-size-12">
                          <span class="text-info">
                            {{ slotProps.option.id }}
                          </span>
                            <span class="mx-4 text-dark">
                            {{ slotProps.option.descricao }}
                          </span>
                          </div>
                          <div class="align-items-end text-end align-content-end font-size-12 text-muted">
                            {{ formatDateTime(slotProps.option.created_at) }}
                          </div>
                        </div>
                      </template>
                    </multiselect>
                  </div>

                  <div class="col-sm-10 mt-2" v-if="tipoTransfer === true">
                    <div class="mb-2">
                      <label for="produto">Código do Item</label>
                      <input id="produto"
                             v-model="transfItemData.produto"
                             type="text"
                             ref="produto"
                             class="form-control compact-input"
                             placeholder="Código Produto"
                             :disabled="dtlistProdSaldoLoc?.length < 1 || (!this.paleteDest || !this.endwmsDestino)"
                             @keypress.enter.prevent="informouProduto"
                             :class="{ 'is-invalid': submitted && !transfItemData.produto }"
                      />
                      <div v-if="submitted && !transfItemData.produto" class="invalid-feedback">
                        <span>Campo nome obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-10 mt-5" v-if="tipoTransfer === true && transfItensSepData.length > 0">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead>
                        <tr>
                          <td style="padding: 0px 2px">Sku</td>
                          <td class="text-danger" style="padding: 0px 2px">Qtd. Disp</td>
                          <td class="text-success" style="padding: 0px 2px">Qtd. Lida</td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr :key="selectedItem?.id">
                          <td v-if="tipoTransfer === true">
                            <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                               @click="clicouProduto(selectedItem)">
                              <h6 class="text-muted mb-0">{{ selectedItem?.produto }} </h6>
                            </a>
                          </td>
                          <td v-else><h6 class="text-muted mb-0">{{ selectedItem?.produto }} </h6></td>
                          <td class="text-danger">{{ selectedItem?.qtddisp }}</td>
                          <td class="text-success">{{ selectedItem?.qtdlida }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                </div>

                <div id="step2" v-if="idData === 0" class="row col-6">

                  <Loader v-if="updating" style="min-height: 400px;">
                  </Loader>

                  <div class="row mb-2" v-if="dtlistProdSaldoLoc?.length > 0 && !updating">
                    <div class="table-responsive" style="max-height: 350px; min-height: 350px; overflow-y: auto;">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th>SKU</th>
                          <th class="text-center">Lote</th>
                          <th class="text-center">Palete</th>
                          <th class="text-center">Qtd. Lida</th>
                          <th class="text-center">Qtd. Total</th>
                        </tr>
                        </thead>
                        <tbody>

                        <template v-for="(data, index) in dtlistProdSaldoLoc" :key="data.produto_id">
                          <!--                        <tr >
                                                    <td class="text-center" colspan="3">Nenhum produto encontrado ou endereço de origem ainda não definido.</td>
                                                  </tr>-->

                          <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                            <td v-if="tipoTransfer === true" style="padding-top: 3px; padding-bottom: 3px;">
                              <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                                 @click="clicouProduto(data)">
                                {{ data.produto }}
                              </a>
                            </td>
                            <td v-else class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ data.produto }}</td>
                            <td class="text-center" style="padding-top: 3px; padding-bottom: 3px;">{{ data.lote ?? 's/lote'  }}</td>
                            <td class="text-center" style="padding-top: 3px; padding-bottom: 3px;">{{ data.palete ?? 's/palete'  }}</td>
                            <td class="text-center" style="padding-top: 3px; padding-bottom: 3px;">{{ formatDecimal(data.qtdlida) }}</td>
                            <td class="text-center" style="padding-top: 3px; padding-bottom: 3px;">{{ formatDecimal(data.qtddisp) }}</td>
                          </tr>
                          <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                            <td colspan="5" class="text-muted small ps-3" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                              {{ data.descprod?.length > 25 ? data.descprod.substring(0, 25) + '...' : data.descprod}}
                            </td>
                          </tr>

                        </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </Layout>
    </div>

    <div v-if="tamanhoTela < 500" class="col-lg-12 full-height-wrapper">

      <div class="card full-height-card">
        <div class="card-body full-height-body">

          <div class="row">
            <div class="col-10">
              <h5>Tranferência de Estoque</h5>
            </div>
            <div v-if="empreAtu" >
              <span class="font-size-10"><strong>Empresa Atual: </strong>
                {{ this.empreAtu.length > 25 ? this.empreAtu.substring(0, 25) + '...' : this.empreAtu}}
              </span>
            </div>

            <button title="Retornar para WmsOS List" @click="retornaParaMenu" class="btn col-1 p-1 m-1 border-0 font-size-16"
                    style="position: fixed; top: 0px; right: 5px; background-color: white; z-index: 1000;">
              <i class="bx bx-undo"></i>
            </button>

            <div class="d-flex justify-content-between"  style="margin-top: 5px">

              <button class="btn p-1 m-1 border-0 font-size-16" @click="atualizaPagina">
                <i class="bx bx-sync"></i>
              </button>

              <button type="button" :disabled="dtlistProdSaldoLoc?.length < 1" class="btn p-1 m-1 border-0 font-size-16"
                      @click="showModalProdSaldoLoc = true">
                <i class="bx bx-list-ul"></i>
              </button>

              <button type="button" class="btn p-1 m-1 border-0 font-size-16" @click="showListConfig = true">
                <i class="bx bx-layer "></i>
              </button>

              <button type="button" class="btn p-1 m-1 border-0 font-size-14" @click="initFullScreen">
                <i class="bx bx-fullscreen"></i>
              </button>

            </div>
          </div>

          <Loader v-if="updating" style="min-height: 400px;">
          </Loader>

          <form class="needs-validation" v-if="!updating">
            <div id="step1" v-if="idData === 0 && activeStep === 1" class="row mb-4">
              <div v-if="idData === 0" class="col-sm-12 mb-5">
                <div class="col-12 d-flex justify-content-start align-items-baseline mb-2">
                  <span class="me-1">{{ defpaletemode === false ? 'Produto Mode' : 'Palete Mode' }}</span>
                  <b-form-checkbox switch size="sm" v-model="defpaletemode" @change="onChange"/>
                </div>

                <div class="mb-2" v-if="!defpaletemode">
                  <label for="inputproduto">Produto de Transferência</label>
                  <input v-if="prodInputMode === true"
                      id="inputproduto"
                      v-model="produtoTransf"
                      type="text"
                      class="form-control compact-input"
                      placeholder="Produto de Transferência ( ID / Código )"
                      ref="inputproduto"
                      @keydown.enter.prevent="escolheuProd"
                  />

                  <multiselect id="origem" v-if="prodInputMode === false"
                               @search-change="pesqProd"
                               @select="escolheuProd"
                               v-model="produtoTransf"
                               class="form-control compact-input"
                               placeholder="Produto de Transferência (ID / Código)"
                               :options="dtlistPesqProd"
                               :searchable="true"
                               ref="inputproduto"
                               label="descricao"
                               track-by="descrcodigo"
                               value-prop="codigo">
                    <template #option="slotProps">
                      <div class="row">
                        <div class="font-size-12">
                            <span class="text-info">
                              {{ slotProps.option.id }}
                            </span>
                          <span class="mx-4 text-dark">
                            {{ slotProps.option.codigo }}
                          </span>
                        </div>
                        <div class="ms-0 font-size-12 text-muted">
                          {{
                            slotProps.option.descricao?.length > 32 ?
                                slotProps.option.descricao.substring(0, 32) + '...' :
                                slotProps.option.descricao
                          }}
                        </div>
                      </div>
                    </template>
                  </multiselect>
                </div>

                <div class="mb-2" v-if="defpaletemode">
                  <label for="palete">Palete</label>
                  <input
                      id="palete"
                      v-model="paleteOrigem"
                      type="text"
                      class="form-control compact-input"
                      placeholder="Palete"
                      ref="palete"
                      @keydown.enter.prevent="informouPalete"
                  />
                </div>

                <div class="mb-3" v-if="!defpaletemode && dtlistPesqEndereco?.length > 0">
                  <label for="origem">Endereço de Origem </label>
                  <multiselect id="origem" v-if="destModoInput === false"
                               @select="escolheuEndOrigem"
                               v-model="endOrigem"
                               placeholder="Selecione o endereçamento de origem"
                               :options="dtlistPesqEndereco"
                               :searchable="false"
                               ref="origem"
                               label="endwmspalete"
                               track-by="endwmspalete"
                               value-prop="id">
                    <template #option="slotProps">
                      <div class="row">
                        <div class="font-size-12">
                          <span class="text-dark">
                            Endereço: {{ slotProps.option.endwms }}
                          </span>
                          <span class="ms-4 text-dark">
                            Palete: {{ slotProps.option.palete ?? 'S/Palete' }}
                          </span>
                        </div>
                        <div class="font-size-12 text-muted">
                          Saldo: {{ formatDecimal(slotProps.option.saldo) }}
                        </div>
                      </div>
                    </template>
                  </multiselect>
                </div>

                <div class="mb-3" v-if="defpaletemode">
                  <label for="origem">Endereço de Origem </label> <!--<span class="text-danger">*</span>-->

                  <input id="origem" v-if="destModoInput === false"
                         v-model="endOrigem"
                         type="text"
                         class="form-control compact-input"
                         placeholder="Definir Origem"
                         ref="origem"
                         @keydown.enter.prevent="escolheuEndOrigem" />

                  <!-- Para tela maior input manual -->
                  <multiselect id="origem" v-if="destModoInput === true"
                               @search-change="pesqEndereco"
                               @select="escolheuEndOrigem"
                               v-model="endOrigem"
                               placeholder="Definir Origem"
                               :options="dtlistPesqEndereco"
                               :searchable="true"
                               ref="origem"
                               label="descricao"
                               track-by="descricao"
                               value-prop="descricao">
                    <template #option="slotProps">
                      <div class="row">
                        <div class="font-size-12">
                            <span class="text-info">
                              {{ slotProps.option.id }}
                            </span>
                          <span class="mx-4 text-dark">
                              {{ slotProps.option.descricao }}
                            </span>
                        </div>
                        <div class="align-items-end text-end align-content-end font-size-12 text-muted">
                          {{ formatDateTime(slotProps.option.created_at) }}
                        </div>
                      </div>
                    </template>
                  </multiselect>

                </div>

                <div class="row mb-2" v-if="dtlistProdSaldoLoc?.length > 0">
                  <div class="table-responsive" style="max-height: 170px; min-height: 170px; overflow-y: auto;">
                    <table class="table align-middle mb-0 table-nowrap">
                      <thead class="table-light">
                      <tr>
                        <th>SKU</th>
                        <th class="text-end">Lote</th>
                        <th class="text-end">Qtd.</th>
                      </tr>
                      </thead>
                      <tbody>

                      <template v-for="(data, index) in dtlistProdSaldoLoc" :key="data.produto_id">

                        <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                          <td v-if="tipoTransfer === true" style="padding-top: 3px; padding-bottom: 3px;">
                            <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                               @click="clicouProduto(data)">
                              {{ data.produto }}
                            </a>
                          </td>
                          <td v-else class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ data.produto }}</td>
                          <td class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ data.lote ?? 's/lote'  }}</td>
                          <td class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ formatDecimal(data.saldo) }}</td>
                        </tr>
                        <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                          <td colspan="3" class="text-muted small ps-3" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                            {{ data.descprod?.length > 25 ? data.descprod.substring(0, 25) + '...' : data.descprod }}
                          </td>
                        </tr>

                      </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="nav-buttons">
                <button type="button" disabled class="btn-nav btn-back">
                  Voltar
                </button>
                <button type="button" class="btn-nav btn-next" @click="definiuOrigem">
                  Próximo
                </button>
              </div>
            </div>

             <div id="step2" v-if="idData === 0 && activeStep === 2" class="row">
               <div class="col-sm-12 mt-1 mb-3" v-if="tipoTransfer === true && transfItensSepData.length > 0">
                 <div class="table-responsive">
                   <table class="table align-middle mb-0 table-nowrap">
                     <thead>
                     <tr>
                       <td style="padding: 0px 2px">Sku</td>
                       <td class="text-danger" style="padding: 0px 2px">Qtd. Disp</td>
                       <td class="text-success" style="padding: 0px 2px">Qtd. Lida</td>
                     </tr>
                     </thead>
                     <tbody>
                     <tr :key="selectedItem?.id">
                       <td v-if="tipoTransfer === true">
                         <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                            @click="clicouProduto(selectedItem)">
                           <h6 class="text-muted mb-0">{{ selectedItem?.produto }} </h6>

                         </a>
                       </td>
                       <td v-else><h6 class="text-muted mb-0">{{ selectedItem?.produto }} </h6></td>
                       <td class="text-danger">{{ selectedItem?.qtddisp }}</td>
                       <td class="text-success">{{ selectedItem?.qtdlida }}</td>
                     </tr>
                     </tbody>
                   </table>
                 </div>
               </div>


               <div class="col-12 d-flex justify-content-between">
                  <div class="col-7">
                    <span class="me-1">End. de Origem: </span>
                    <label v-if="endwmsOrigem" for="viewOrigem">
                      {{ endwmsOrigem }}
                    </label>
                  </div>
                  <div class="col-4">
                    <span class="me-1">Palete: </span>
                    <label v-if="paleteOrigem" for="viewPaleteOrigem">
                      {{ paleteOrigem }}
                    </label>
                  </div>
               </div>

               <div class="d-flex justify-content-between col-12 mb-3">
                 <div class="col-5 ">
                   <label for="paletedest">Palete Destino</label>
                   <input
                       id="paletedest"
                       v-model="paleteDest"
                       type="text"
                       class="form-control compact-input"
                       placeholder="Palete Destino"
                       ref="paletedest"
                       @keydown.enter.prevent="informouPaleteDest"
                   />
                 </div>

                 <div class="col-6">
                   <label for="destino">Endereço Destino</label>
                   <input id="destino" v-if="destModoInput === false"
                          v-model="endwmsDestino"
                          type="text"
                          class="form-control compact-input"
                          placeholder="Endereço Destino"
                          ref="destino"
                          @keydown.enter.prevent="escolheuEndDestino" />

                   <!-- Para tela maior input manual -->
                   <multiselect id="destino" v-if="destModoInput === true"
                                @search-change="pesqEndwmsDest"
                                @select="escolheuEndDestino"
                                v-model="endwmsDestino"
                                placeholder="End. Destino"
                                :options="dtlistPesqEndwmsDest"
                                :searchable="true"
                                ref="destino"
                                label="descricao"
                                track-by="descricao"
                                value-prop="descricao">
                     <template #option="slotProps">
                       <div class="row">
                         <div class="font-size-12">
                          <span class="text-info">
                            {{ slotProps.option.id }}
                          </span>
                           <span class="mx-4 text-dark">
                            {{ slotProps.option.descricao }}
                          </span>
                         </div>
                         <div class="align-items-end text-end align-content-end font-size-12 text-muted">
                           {{ formatDateTime(slotProps.option.created_at) }}
                         </div>
                       </div>
                     </template>
                   </multiselect>
                 </div>
               </div>


               <div class="col-sm-12" v-if="tipoTransfer === true">
                 <div class="mb-2">
                   <label for="produto">Código do Item</label>
                   <input id="produto"
                          v-model="transfItemData.produto"
                          type="text"
                          ref="produto"
                          class="form-control compact-input"
                          placeholder="Código Produto"
                          @keypress.enter.prevent="informouProduto"
                          :class="{ 'is-invalid': submitted && !transfItemData.produto }"
                   />
                   <div v-if="submitted && !transfItemData.produto" class="invalid-feedback">
                     <span>Campo nome obrigatório, favor preencher.</span>
                   </div>
                 </div>
               </div>

               <div class="nav-buttons">
                 <button type="button" class="btn-nav btn-back" @click="goToStep(1)" >
                   Voltar
                 </button>

                 <button v-if="tipoTransfer === true"
                         type="button"
                         class="btn-nav btn-next"
                         @click="informouProduto">
                   Próximo
                 </button>
                 <button v-else
                         type="button"
                         class="btn-nav btn-next"
                         @click="confirmarRemanejo">
                   Finalizar Transf.
                 </button>
               </div>
             </div>
          </form>

        </div>
      </div>
    </div>

    <b-modal title="Produtos para Transferência" v-model="showModalProdSaldoLoc" centered hide-footer @hidden="fechouModalProdSaldoLoc">
      <div class="col-md-12">
        <div class="mb-1">
          <span>Origem: </span>
          <label v-if="endwmsOrigem" for="viewOrigem">
            {{ endwmsOrigem }}
          </label>
        </div>

        <div class="table-responsive" style="max-height: 280px; min-height: 280px; overflow-y: auto;">
          <table v-if="dtlistProdSaldoLoc" class="table align-middle mb-0 table-nowrap">
            <thead class="table-light">
            <tr>
              <th class="text-center">SKU</th>
              <th class="text-center">Lidos</th>
              <th class="text-center">Total</th>
            </tr>
            </thead>
            <tbody>

            <template v-for="(data, index) in dtlistProdSaldoLoc" :key="data.produto_id">
              <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                <td v-if="tipoTransfer === true" style="padding-top: 3px; padding-bottom: 3px;">
                  <a href="javascript: void(0);" class="text-center text-body fw-bold text-wrap"
                     @click="clicouProduto(data)">
                    {{ data.produto }}
                  </a>
                </td>
                <td v-else class="text-center" style="padding-top: 3px; padding-bottom: 3px;">{{ data.produto }}</td>
                <td class="text-center" style="padding-top: 3px; padding-bottom: 3px;">{{ formatDecimal(data.qtdlida) }}</td>
                <td class="text-center" style="padding-top: 3px; padding-bottom: 3px;">{{ formatDecimal(data.qtddisp) }}</td>
              </tr>
              <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
<!--                <td colspan="4" class="text-muted small ps-2" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">-->
<!--                  {{ data.descprod?.length > 20 ? data.descprod.substring(0, 20) + '...  '-->
<!--                    + (data.lote ? 'Lote:' + data.lote : 's/Lote')  + ' | ' + (data.palete ? 'Palete:' + data.palete : 's/Palete')-->
<!--                    : data.descprod + ' ' + (data.lote ? 'Lote:' + data.lote : 's/Lote')-->
<!--                    + ' | ' + (data.palete ? 'Palete:' + data.palete : 's/Palete')-->
<!--                  }}-->
<!--                </td>-->
                <td class="text-muted text-center small" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                  {{ data.descprod?.length > 15 ? data.descprod.substring(0, 15) + '...' : data.descprod }}
                </td>
                <td class="text-muted text-center small" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                  {{ (data.lote ? 'Lote:' + data.lote : 's/Lote') }}
                </td>
                <td class="text-muted text-center small" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                  {{ (data.palete ? 'Palete:' + data.palete : 's/Palete') }}
                </td>

              </tr>

            </template>
            </tbody>
          </table>
        </div>
      </div>

    </b-modal>

    <b-modal title="Confer. Manual" v-model="showConfManual" centered hide-footer> <!--@shown="onModalConfManual"-->
      <div class="col-md-12">

        <!--                  Modal para colocar itens quando conf. for manual-->

        <div class="col-sm-6" v-if="selectedItem?.id">
          <div class="mb-3">
            <label for="codprod">Código do Item</label>
            <input id="codprod" v-model="selectedItem.produto" type="text" class="form-control"
                   disabled />
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <label for="qtd">Qtd. Itens</label>
            <input id="qtd" v-model="transfItemData.qtd" type="number" :disabled="true" class="form-control"
                   placeholder="Quantidade de Itens" />
          </div>

          <div class="col-6">
            <label for="qtdlida">Qtd. Disp.</label>
            <input id="qtdlida" ref="qtdlida" v-model="transfItemData.qtdlida" type="number"
                   class="form-control" :disabled="tipoConfer === 'A'" @keypress.enter="informouQtdLida2()"
                   placeholder="Quantidade a ser lida" />
          </div>
        </div>

        <div class="row justify-content-around mt-3">
          <b-button class="col-5 btn-sm py-1" variant="light" @click="showConfManual = false">
            <i class="bx bx-block font-size-14 align-middle me-1"></i>
            <span class="small">Cancelar</span>
          </b-button>
          <b-button type="submit" variant="success" class="col-5 btn-sm py-1"
                    @click="informouQtdLida2()">
            <i class="bx bx-check-double font-size-14 align-middle me-1"></i>
            <span class="small">Confirmar</span>
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal title="Configurações" v-model="showListConfig" centered hide-footer @hidden="fechouModalListConfig">
      <div class="col-md-12">
        <div class="col-12">
          <a v-if="endOrigem && endwmsDestino" class="dropdown-item text-primary text-center" href="javascript: void(0);" @click="confirmarRemanejo">
            <i class="bx bx-check-double"></i>
            Finalizar Trasnfer.
          </a>
          <a v-else disabled class="dropdown-item text-muted text-center" href="javascript: void(0);">
            <i class="bx bx-check-double"></i>
            Finalizar Trasnfer.
          </a>
        </div>

        <hr>

        <div class="col-12 d-flex justify-content-start">
          <b-form-checkbox switch size="sm" v-model="prodInputMode" @change="onChange">
            {{ prodInputMode === false ? 'Prod. Modo Multiselect' : 'Prod. Modo Input' }}
          </b-form-checkbox>
        </div>
        <div class="col-12 d-flex justify-content-start">
          <b-form-checkbox switch size="sm" v-model="tipoTransfer">
            {{ tipoTransfer === false ? 'Modo Full' : 'Modo Unit.' }}
          </b-form-checkbox>
        </div>
        <div class="col-12 d-flex justify-content-start">
          <b-form-checkbox switch size="sm" v-model="destModoInput">
            {{ destModoInput === false ? 'End. Modo Input' : 'End. Modo Multiselect' }}
          </b-form-checkbox>
        </div>
        <div class="col-12 d-flex justify-content-start">
          <b-form-checkbox switch size="sm" value="A" unchecked-value="I" v-model="tipoConfer">
            {{ tipoConfer === 'A' ? 'Conf. Auto' : 'Conf. Manual' }}
          </b-form-checkbox>
        </div>
      </div>
    </b-modal>

</template>

<style scoped>
.full-height-wrapper {
  height: 100vh;
  overflow: hidden;
}

.full-height-card {
  height: 100%;
  margin-bottom: 0;
  border-radius: 0;
}

.full-height-body {
  height: 100%;
  overflow: hidden;
}


.btn-compact {
  background: none;
  border: 1px solid #ddd;
  padding: 3px 6px;
  border-radius: 3px;
  font-size: 12px;
  min-width: 28px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-compact:hover {
  background-color: #f5f5f5;
}

.compact-input {
  font-size: 12px;
  padding: 4px 6px;
  height: 32px;
  border-radius: 3px;
  border: 1px solid #ddd;
  width: 100%;
}

.compact-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 1px rgba(0,123,255,.25);
  outline: none;
}

.compact-input.is-invalid {
  border-color: #dc3545;
}

.error-msg {
  font-size: 9px;
  color: #dc3545;
  margin-top: 2px;
}

.client-info {
  background: #f8f9fa;
  padding: 4px 6px;
  border-radius: 3px;
  margin-bottom: 6px;
  font-size: 10px;
}

.client-name {
  font-weight: 600;
  display: block;
  color: #333;
  line-height: 1.2;
}

.client-detail {
  color: #666;
  font-size: 9px;
}

.item-info {
  background: #e8f4f8;
  padding: 4px 6px;
  border-radius: 3px;
  margin-bottom: 8px;
  font-size: 10px;
}

.item-row {
  display: flex;
  justify-content: space-between;
  line-height: 1.3;
}

.item-label {
  font-weight: 600;
  color: #555;
}

.item-value {
  color: #333;
  font-weight: 500;
}

.nav-buttons {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #ddd;
  z-index: 1000;
  gap: 6px;
}

.btn-nav {
  flex: 1;
  padding: 6px 4px;
  font-size: 10px;
  font-weight: 600;
  border-radius: 3px;
  border: 1px solid;
  background: white;
  height: 28px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-back {
  border-color: #6c757d;
  color: #6c757d;
}

.btn-back:hover:not(:disabled) {
  background-color: #6c757d;
  color: white;
}

.btn-back:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-next {
  border-color: #28a745;
  color: #28a745;
}

.btn-next:hover {
  background-color: #28a745;
  color: white;
}
</style>
